import React, { Component } from 'react';

import { GenericModal, GenericOption, GenericSelect, GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';

import CheckPerfil from './CheckPerfil';

class PopUpPerfiles extends Component {
    constructor(props) {
        super(props);

        this.state = {
            productId: "0",
            profilesList: [],
            selectedProfiles: [],
            modalOpen: false
        }
    }

    componentDidMount() {
        this.setState({
            profilesList: this.props.perfiles,
            selectedProfiles: this.props.perfilesSeleccionados
        });
    }

    componentWillReceiveProps(nextProps) {
        //if (this.state.modalOpen === false) {
            this.setState({
                    productId: "0",
                    profilesList: nextProps.perfiles,
                    selectedProfiles: nextProps.perfilesSeleccionados,
                    modalOpen: true
            });
        // }
    }

    onHandleSelectChangeProduct = (e) => {
        this.setState({
            productId: e.target.value
        });
    }

    checkItem = (e) => {
        let id = e.target.value;
        let checked = e.target.checked;
        let updatedList = JSON.parse(JSON.stringify(this.state.selectedProfiles));

        if (checked === false) {
            let perfilIndex = this.state.selectedProfiles.findIndex(x => x.Id == id);
            updatedList.splice(perfilIndex, 1);
        }
        else if (checked === true) {
            let perfil = this.state.profilesList.find(x => x.Id == id);
            updatedList.push(perfil);
        }

        this.setState({
            selectedProfiles: updatedList
        });
    }

    reset = () => {
        this.setState({
            productId: "0",
            selectedProfiles: [],
            modalOpen: false
        });
    }

    save = () => {
        this.props.savePerfiles(this.state.selectedProfiles)

        this.setState({
            productId: "0",
            selectedProfiles: [],
            modalOpen: false
        });
    }

    render() {
        const { props } = this;
        const { state } = this;

        let products = JSON.parse(JSON.stringify(props.productos));
        //products.unshift({ Id: 0, Descripcion: "Seleccione un producto..." });

        let oProducto = products.map((product) => {
            let selected = product.Id == state.productId ? true : false;
            return <GenericOption selected={selected} id={product.Id} description={product.Descripcion} key={"NewProduct_" + product.Id} />
        });

        let checked;
        let perfilesNodes = state.profilesList.map((p) => {
            if (state.productId == "0" ||
                (p.ProductoId == null) ||
                (p.ProductoId == state.productId)) {
                checked = (state.selectedProfiles.find(x => x.Id == p.Id) != undefined);

                return <CheckPerfil id={p.Id}
                    key={"Profile_" + p.Id}
                    codigo={p.Codigo}
                    checked={checked}
                    checkItem={this.checkItem}
                />
            }            
        });

        return (
            <div className="modal fade-out" id="listProfileModal" role="dialog" data-backdrop="static">
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header" data-label="Título">
                            <div className="close" data-dismiss="modal" aria-hidden="true">
                                <label className="ti-close clickable"></label>
                            </div>
                            <h2 className="modal-title">Perfiles</h2>
                        </div>

                        <div className="modal-body">
                            <div className="form-group bottom-separator-xs">
                                <GenericSelect id="selProductos"
                                    options={oProducto}
                                    className="form-control default-input"
                                    onChange={this.onHandleSelectChangeProduct} />
                            </div>
                            <div className="vertical-scrollable-container-md">
                                {perfilesNodes}
                            </div>
                        </div>

                        <div className="modal-footer">
                            <div className="row">
                                <div className="col-xs-5">
                                    <GenericSimpleButton text="Guardar"
                                        buttonClass="btn btn-primary btn-cta"
                                        dataDismiss="modal"
                                        onClick={this.save} />
                                </div>
                                <div className="col-xs-7">
                                    <GenericSimpleButton text="Cancelar"
                                        buttonClass="btn btn-default btn-secondary"
                                        dataDismiss="modal"
                                        onClick={this.reset} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PopUpPerfiles;